
import Error from '../Components/Error/Error';

import Dashboard from '../Components/Dashboard/Dashboard';

import TicketDetail from '../Components/TicketDetail/TicketDetail';
import CallTickets from '../Components/Tickets/CallTickets';
import Login from '../Components/Login/Login';
import ForgotPassword from '../Components/ForgotPassword/ForgotPassword';
import ResetPassword from '../Components/ResetPassword/ResetPassword';
import MyTickets from '../Components/MyTickets/MyTickets';
import PublishPanel from '../Components/PublishPanel/PublishPanel';
import DashboardDepartment from '../Components/DashboardDepartment/DashboardDepartment';
import DepartmentTickets from '../Components/DepartmentTickets/DepartmentTickets';
import DepartMentTicketDetail from '../Components/DepartMentTicketDetail/DepartMentTicketDetail';
import Departments from '../Components/DepartmentsList/DepartmentsList';
import FAQ from '../Components/FAQ/FAQ';
import PluginSupport from '../Components/PluginSupport/PluginSupport';
import DataService from '../Components/DataService/DataService';
import DataPolicy from '../Components/DataPolicy/DataPolicy';
import CallCareSupport from '../Components/CallCareSupport/CallCareSupport';

export const routes = () => [
  { path: '/', element: Login , pvtRoute: false,role:['admin','contributor','compliance analyst'] }, // Public route (login)
  {
    path: '/',
    element: Login,
    pvtRoute: false,role:['admin','contributor','compliance analyst']
  },


  {
    path: 'Dashboard',
    element: Dashboard,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'FAQ',
    element: FAQ,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'DataPolicy',
    element: DataPolicy,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },

  {
    path: 'PluginSupport',
    element: PluginSupport,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },


  {
    path: 'Department',
    element: DashboardDepartment,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'reset-password/:id/:check',
    element: ResetPassword,pvtRoute: false,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'forgot-password',
    element: ForgotPassword,
    role:['admin','contributor','compliance analyst']
  },


  {
    path: 'ticket-detail/:id',
    element: TicketDetail,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'Agent-care',
    element: CallTickets,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },

  {
    path: 'Call-care-support',
    element: CallCareSupport,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'publishing-panel',
    element: PublishPanel,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'Departments-tickets',
    element: DepartmentTickets,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },

  {
    path: 'My-tickets',
    element: MyTickets,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'tickets-detail-department/:id',
    element: DepartMentTicketDetail,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },
  {
    path: 'DataService',
    element: DataService,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },



  {
    path: 'Departments',
    element: Departments,
    pvtRoute: true,role:['admin','contributor','compliance analyst']
  },

  { path: '*', element: Error }, // Error route

];
